// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import React from "react";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-1knm89g-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);

/**
 * Navigation aid to direct user to additional operations previous or to the left.
 *
 * @param {object} props - The component props
 * @param {string} [props.size] - The width/height of the icon as any CSS size unit
 * @param {string} [props.color] - The fill color of the icon as any CSS color value
 * @param {string} [props.title] - The title to add as a child of the root svg element
 *
 * @returns {React.ReactElement} - The ChevronLeftLarge component
 */
const ChevronLeftLarge = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M6.621 11.9l8.307-8.307a.75.75 0 1 0-1.06-1.06l-8.836 8.834a.749.749 0 0 0-.006 1.059l.006.006 8.837 8.837a.745.745 0 0 0 1.06 0 .748.748 0 0 0 0-1.061l-8.308-8.309z",
    children: " "
  })]
});
export default ChevronLeftLarge;